import React, { useState } from 'react'
import { MdOutlineAccountCircle, MdOutlineMail, MdOutlinePhone, MdOutlinePhoneIphone, MdKeyboardArrowDown, MdKeyboardArrowUp, MdMonetizationOn } from "react-icons/md";
import dayjs from 'dayjs'
import 'dayjs/locale/es'

import { Card, Table, Box, Text, Badge, Button, ActionIcon, Flex, Grid, Group, Tooltip, Stack } from '@mantine/core'

const RowHome = ({ item, today, tenDays, openModal }) =>
{
  const [ show, setShow ] = useState(false)
  const limit_date = dayjs(item?.limit_date_billing);
  const isExpired = limit_date.isBefore(dayjs(), 'day');
  const isToday = limit_date.isSame(dayjs(), 'day');
  const isSoon = limit_date.isBefore(dayjs().add(10, 'day')) && !isExpired && !isToday;

  const getUrgencyColor = () => {
    if (isExpired) return 'red';
    if (isToday) return 'orange';
    if (isSoon) return 'yellow';
    return 'green';
  };

  const getStatusLabel = () => {
    if (isExpired) return 'VENCIDO';
    if (isToday) return 'VENCE HOY';
    if (isSoon) return 'VENCE PRONTO';
    return 'AL CORRIENTE';
  };

  return (
    <>
      <Table.Tr
        className={`transition-colors duration-200 ${show ? 'bg-slate-50' : 'hover:bg-slate-50/50'}`}
        style={show ? { borderLeft: `4px solid var(--mantine-color-${getUrgencyColor()}-6)` } : { borderLeft: '4px solid transparent' }}
      >
        <Table.Td px="md" py="md">
          <Badge variant="filled" color={getUrgencyColor()} size="xs" radius="xs" fw={800} style={{ letterSpacing: '0.5px' }}>
            {getStatusLabel()}
          </Badge>
        </Table.Td>
        
        <Table.Td>
          <Text size="sm" fw={600} c="dimmed">
            { dayjs(item?.date_billing).locale('es').format('DD/MMM/YYYY').toUpperCase() }
          </Text>
        </Table.Td>

        <Table.Td>
          <Text size="sm" fw={700} c={isExpired ? 'red.7' : 'dark.4'}>
            { limit_date.locale('es').format('DD/MMM/YYYY').toUpperCase() }
          </Text>
        </Table.Td>

        <Table.Td>
          <Box>
            <Text fw={700} size="sm">{ item.num_account }</Text>
            <Text size="xs" c="dimmed" truncate maxW={180}>{ item?.full_name || 'N/A' }</Text>
          </Box>
        </Table.Td>

        <Table.Td align='right'>
          <Flex justify="flex-end" align="center" gap="xs">
            <Button 
              variant='light' 
              color="yellow" 
              size="xs" 
              radius="md" 
              autoContrast 
              leftSection={<MdMonetizationOn size={16} />}
              onClick={ () => openModal(item) }
            >
              Renovar
            </Button>
            <Tooltip label={show ? 'Cerrar detalle' : 'Ver más info'} fontSize="xs">
              <ActionIcon 
                size="lg" 
                variant={show ? 'filled' : 'subtle'} 
                color="gray.7" 
                radius="md"
                onClick={ () => setShow(!show) }
              >
                { show ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown /> }
              </ActionIcon>
            </Tooltip>
          </Flex>
        </Table.Td>
      </Table.Tr>

      { show && (
        <Table.Tr style={{ borderLeft: `4px solid var(--mantine-color-${getUrgencyColor()}-6)`, backgroundColor: 'var(--mantine-color-slate-50)' }}>
          <Table.Td colSpan={ 5 } px="xl" py="lg">
            <Box className='grid grid-cols-1 md:grid-cols-2 gap-8'>
              <Box>
                <Text size="xs" fw={800} c="dimmed" mb="md" className="tracking-widest uppercase">Información del Cliente</Text>
                <Grid gap="sm">
                  <Grid.Col span={ 12 }>
                    <Flex align='center' gap="xs">
                      <MdOutlineAccountCircle size={18} className="text-yellow-600" /> 
                      <Text size="sm" fw={600}>{ item?.full_name || 'N/A' }</Text>
                    </Flex>
                  </Grid.Col>
                  <Grid.Col span={ 12 }>
                    <Flex align='center' gap="xs">
                      <MdOutlineMail size={18} className="text-yellow-600" /> 
                      <Text size="sm">{ item?.email || 'N/A' }</Text>
                    </Flex>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Flex align='center' gap="xs">
                      <MdOutlinePhone size={18} className="text-yellow-600" /> 
                      <Text size="sm">{ item?.phone || 'N/A' }</Text>
                    </Flex>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Flex align='center' gap="xs">
                      <MdOutlinePhoneIphone size={18} className="text-yellow-600" /> 
                      <Text size="sm">{ item?.cellphone || 'N/A' }</Text>
                    </Flex>
                  </Grid.Col>
                </Grid>
              </Box>

              <Box>
                <Text size="xs" fw={800} c="dimmed" mb="md" className="tracking-widest uppercase">Detalle del Servicio</Text>
                <Stack gap={4}>
                  <Flex justify="space-between" align="center">
                    <Text size="xs" fw={700}>MODALIDAD:</Text>
                    <Badge variant="light" color="gray" radius="sm">{ item?.type_contract }</Badge>
                  </Flex>
                  <Flex justify="space-between" align="center">
                    <Text size="xs" fw={700}>PLAN ACTUAL:</Text>
                    <Text size="sm" fw={600}>{ item?.name_type_plan }</Text>
                  </Flex>
                  <Flex justify="space-between" align="center">
                    <Text size="xs" fw={700}>COSTO MENSUAL:</Text>
                    <Text size="md" fw={800} c="dark.4" className="font-mono">${ item?.price_type_plan }</Text>
                  </Flex>
                </Stack>
              </Box>
            </Box>
          </Table.Td>
        </Table.Tr>
      ) }
    </>
  )
}

export default RowHome
